export default "__VITE_ASSET__D_ELi6IA__"